/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Features_Trackprices1Inputs */

const id_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lacak perubahan harga game dan data historis`)
};

const ms_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jejak perubahan harga permainan dan data sejarah`)
};

const da_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor spilprisændringer og historiske data`)
};

const de_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgen Sie Spielpreisänderungen und historische Daten`)
};

const en_us2_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track game price changes and historical data`)
};

const es_es2_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastrea cambios de precios de juegos y datos históricos`)
};

const es_mx2_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastrea cambios de precios de juegos y datos históricos`)
};

const fil_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subaybayan ang mga pagbabago ng presyo ng laro at historical data`)
};

const fr_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre les changements de prix des jeux et les données historiques`)
};

const it_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia le variazioni di prezzo dei giochi e i dati storici`)
};

const hu_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékárak változásainak és előzményeinek követése`)
};

const nl_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg prijswijzigingen van games en historische gegevens`)
};

const no_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spor prisendringer og historiske data for spill`)
};

const pl_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź zmiany cen gier i dane historyczne`)
};

const pt_br2_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe alterações de preços de jogos e dados históricos`)
};

const pt_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acompanhe alterações de preços e dados históricos`)
};

const ro_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urmărește modificările de preț și datele istorice`)
};

const fi_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraa pelien hintamuutoksia ja historiatietoja`)
};

const sv_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spåra prisförändringar och historisk data för spel`)
};

const vi_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi thay đổi giá game và dữ liệu lịch sử`)
};

const tr_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun fiyat değişikliklerini ve geçmiş verileri takip edin`)
};

const cs_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledujte změny cen her a historická data`)
};

const bg_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проследявайте промените в цените на игрите и исторически данни`)
};

const ru_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживайте изменения цен на игры и исторические данные`)
};

const uk_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відстежуйте зміни цін та історичні дані ігор`)
};

const ar_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع تغييرات أسعار الألعاب والبيانات التاريخية`)
};

const hi_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम की कीमतों में बदलाव और ऐतिहासिक डेटा ट्रैक करें`)
};

const th_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามการเปลี่ยนแปลงราคาเกมและข้อมูลประวัติ`)
};

const ja_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームの価格変更と履歴データを追跡`)
};

const zh_cn2_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追踪游戏价格变动和历史数据`)
};

const zh_hant1_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤遊戲價格變動和歷史資料`)
};

const ko_about_features_trackprices1 = /** @type {(inputs: About_Features_Trackprices1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 가격 변동 및 과거 데이터 추적`)
};

/**
* | output |
* | --- |
* | "Track game price changes and historical data" |
*
* @param {About_Features_Trackprices1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_features_trackprices1 = /** @type {((inputs?: About_Features_Trackprices1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Features_Trackprices1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_features_trackprices1(inputs)
	if (locale === "ms") return ms_about_features_trackprices1(inputs)
	if (locale === "da") return da_about_features_trackprices1(inputs)
	if (locale === "de") return de_about_features_trackprices1(inputs)
	if (locale === "en-US") return en_us2_about_features_trackprices1(inputs)
	if (locale === "es-ES") return es_es2_about_features_trackprices1(inputs)
	if (locale === "es-MX") return es_mx2_about_features_trackprices1(inputs)
	if (locale === "fil") return fil_about_features_trackprices1(inputs)
	if (locale === "fr") return fr_about_features_trackprices1(inputs)
	if (locale === "it") return it_about_features_trackprices1(inputs)
	if (locale === "hu") return hu_about_features_trackprices1(inputs)
	if (locale === "nl") return nl_about_features_trackprices1(inputs)
	if (locale === "no") return no_about_features_trackprices1(inputs)
	if (locale === "pl") return pl_about_features_trackprices1(inputs)
	if (locale === "pt-BR") return pt_br2_about_features_trackprices1(inputs)
	if (locale === "pt") return pt_about_features_trackprices1(inputs)
	if (locale === "ro") return ro_about_features_trackprices1(inputs)
	if (locale === "fi") return fi_about_features_trackprices1(inputs)
	if (locale === "sv") return sv_about_features_trackprices1(inputs)
	if (locale === "vi") return vi_about_features_trackprices1(inputs)
	if (locale === "tr") return tr_about_features_trackprices1(inputs)
	if (locale === "cs") return cs_about_features_trackprices1(inputs)
	if (locale === "bg") return bg_about_features_trackprices1(inputs)
	if (locale === "ru") return ru_about_features_trackprices1(inputs)
	if (locale === "uk") return uk_about_features_trackprices1(inputs)
	if (locale === "ar") return ar_about_features_trackprices1(inputs)
	if (locale === "hi") return hi_about_features_trackprices1(inputs)
	if (locale === "th") return th_about_features_trackprices1(inputs)
	if (locale === "ja") return ja_about_features_trackprices1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_features_trackprices1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_features_trackprices1(inputs)
	return ko_about_features_trackprices1(inputs)
});
export { about_features_trackprices1 as "about.features.trackPrices" }